import type { SetPieceSchedule } from '../segments/SegmentDefinition';

/**
 * Run distance (m) of the `index`-th mark (0-based) of a set-piece schedule: the marks of all stretches in
 * order – `from`, `from + every`, … up to `until` – the last stretch open-ended. Undefined past the end of a
 * schedule whose last stretch has an `until`. `shift` moves every mark (testing aid ?segment=, see LevelGenerator).
 */
export function scheduleMark(schedule: SetPieceSchedule, index: number, shift = 0): number | undefined {
  let remaining = index;
  for (const stretch of schedule.stretches) {
    const count = stretch.until === undefined ? Infinity : Math.floor((stretch.until - stretch.from) / stretch.every + 1e-9) + 1;
    if (remaining < count) return stretch.from + remaining * stretch.every + shift;
    remaining -= count;
  }
  return undefined;
}

/** All marks of the schedule up to `distance` (inclusive), in order. */
export function scheduleMarksUpTo(schedule: SetPieceSchedule, distance: number): number[] {
  const marks: number[] = [];
  for (let i = 0; ; i++) {
    const mark = scheduleMark(schedule, i);
    if (mark === undefined || mark > distance) return marks;
    marks.push(mark);
  }
}
